import { OrganizationResponse } from '@/common/models/response.model';
import { Organization } from '@/reservation/reservation.model';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-organization-list',
	templateUrl: './organization-list.component.html',
	styleUrls: ['./organization-list.component.css'],
})
export class OrganizationListComponent extends ListComponent implements AfterViewInit, OnInit {
	@ViewChild('dataTable') table: MatTable<Organization>;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	showTable = true;
	matData = new MatTableDataSource<Organization>();
	sellCategorySet: any;

	parameters: any = {
		isOskar: null,
		locations: null,
		isActive: null,
	};

	displayedColumns: string[] = [
		'lp',
		'shortName',
		'name',
		'sellCategory',
		'nip',
		'merlinxCode',
		'nawigatorID',
		'isOskar',
		'isActive',
		'edit',
	];

	protected itemsBeforeDataLoad = 2;
	protected apiUrl = 'organization';
	protected apiType = 'bag';
	protected filterValue = '';

	ngAfterViewInit(): void {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	matchSellCategory(element: number): string {
		const foundValue = this.sellCategorySet.find((singleCategory) => singleCategory.id === element);

		return foundValue ? foundValue.name : '';
	}

	refreshFilter(): void {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	protected loadBefore(): void {
		this.bag.get('/location/?limit=9999', (result) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.locations = result.results;
			this.loadData();
		});
		this.bag.get('/sell_category/', (result) => {
			this.sellCategorySet = result.results;
			this.loadData();
		});
	}

	protected convertData(result: OrganizationResponse): void {
		this.matData.data = result.results;
		this.showTable = this.matData.data.length !== 0;
	}
}
